import { reviews } from "@/mocks/animeData";

export default function ReviewsSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="relative bg-background-950 rounded-3xl overflow-visible p-8 md:p-14">
            <div className="absolute -top-8 -left-4 md:-left-8 w-24 h-24 opacity-20">
              <svg viewBox="0 0 100 100" className="w-full h-full">
                <path
                  d="M10 90 Q 30 10 50 60 Q 70 110 90 20"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="text-foreground-300"
                />
              </svg>
            </div>

            <div className="flex flex-col lg:flex-row gap-10 lg:gap-0">
              <div className="lg:w-5/12 flex-shrink-0">
                <div className="relative -mt-20 md:-mt-24 lg:-ml-20 lg:-my-16">
                  <div className="w-48 h-56 md:w-56 md:h-72 rounded-2xl overflow-hidden">
                    <img
                      src={reviews[0].avatar}
                      alt={reviews[0].name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute -bottom-3 -right-3 w-10 h-10 bg-accent-500 rounded-full flex items-center justify-center">
                    <i className="ri-double-quotes-l text-white text-sm"></i>
                  </div>
                </div>
              </div>

              <div className="lg:w-7/12 flex flex-col justify-center">
                <span className="text-7xl md:text-9xl font-serif text-accent-500/30 leading-none select-none">
                  &ldquo;
                </span>

                <p className="text-white/90 text-base md:text-lg leading-relaxed -mt-6">
                  {reviews[0].content}
                </p>

                <div className="mt-8">
                  <p className="text-white text-base font-semibold">{reviews[0].name}</p>
                  <p className="text-foreground-500 text-sm">{reviews[0].role}</p>
                </div>

                <a
                  href="#"
                  className="inline-flex items-center gap-2 mt-8 px-5 py-2.5 rounded-full bg-primary-500/90 text-white text-sm font-medium hover:bg-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看更多评价
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
            {reviews.slice(1).map((review, idx) => (
              <div
                key={idx}
                className="bg-background-100 rounded-2xl p-6 md:p-8"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={review.avatar}
                      alt={review.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                    <p className="text-xs text-foreground-500">{review.role}</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{review.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}